import React from 'react';
import {AiFillStar} from 'react-icons/ai';
import {permColors} from '../../utils/colors';

const starStyle = {
	color: 'gold',
	fontSize: '1.3em',
};

export default function GoogleReviews() {
	return (
		<div className="flex gap-2 mt-3  duration-300 w-fit">
			<img src="/images/google_logo.png" alt="Google Reviews" width={45} height={45} />
			<div>
				<div className="flex gap-1 mb-1">
					<AiFillStar style={starStyle} />
					<AiFillStar style={starStyle} />
					<AiFillStar style={starStyle} />
					<AiFillStar style={starStyle} />
					<AiFillStar style={starStyle} />
				</div>
				<p className="text-sm font-bold" style={{color: permColors.white}}>
					5.0 Star Ratings
				</p>
			</div>
		</div>
	);
}
